import React, { useEffect, useRef } from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import logo from "../assets/images/krinvy_services.gif";
import Cosection from '../components/Cosections';
import Scrolltop from '../components/Scrolltop';
import WhatsAppChatButton from '../components/Whatsapp';
import "./Services.css";
import AOS from 'aos';
import 'aos/dist/aos.css';

// Initialize AOS
AOS.init({
  duration: 800,
  easing: 'ease-in-out',
  once: true,
  mirror: false
});

const Services = ({ showQuoteModal, setShowQuoteModal }) => {
  const modalIntervalRef = useRef(null);

  useEffect(() => {
    // Initialize AOS
    AOS.refresh();

    // Modal handling logic
    const showModalIfNotOpen = () => {
      if (!showQuoteModal) {
        setShowQuoteModal(true);
      }
    };

    if (!showQuoteModal) {
      modalIntervalRef.current = setInterval(showModalIfNotOpen, 120000);
    }

    return () => {
      if (modalIntervalRef.current) {
        clearInterval(modalIntervalRef.current);
      }
    };
  }, [showQuoteModal, setShowQuoteModal]);

  // Additional effect to restart interval when modal closes
  useEffect(() => {
    if (!showQuoteModal && !modalIntervalRef.current) {
      modalIntervalRef.current = setInterval(() => {
        if (!showQuoteModal) {
          setShowQuoteModal(true);
        }
      }, 120000);
    }
    
    return () => {
      if (modalIntervalRef.current) {
        clearInterval(modalIntervalRef.current);
      }
    };
  }, [showQuoteModal, setShowQuoteModal]);

 const serviceCategories = [
  {
    category: "Financial Services",
    services: [
      { 
        title: "Tax & Accounting", 
        desc: "Comprehensive tax solutions including GST, Income Tax, TDS filings (India) and Federal/State filings (US) with audit support",
        details: [
          "Monthly/quarterly bookkeeping",
          "Financial statement preparation",
          "Tax planning and advisory",
          "Cross-border taxation",
          "Audit representation"
        ]
      },
      { 
        title: "Payroll Management", 
        desc: "End-to-end payroll processing with compliance management",
        details: [
          "Salary processing with bank integration",
          "PF, ESI, PT deductions (India)",
          "401(k), Social Security (US)",
          "Employee self-service portals",
          "Leave management integration"
        ]
      },
      { 
        title: "Business Registration", 
        desc: "Complete company formation services for multiple business types",
        details: [
          "Private Limited, LLP, OPC (India)",
          "LLC, S-Corp, C-Corp (US)",
          "Tax ID registration (PAN/TAN, EIN)",
          "Business licensing",
          "Post-incorporation compliance"
        ]
      }
    ]
  },
  {
    category: "Legal & Compliance",
    services: [
      { 
        title: "Legal Support", 
        desc: "Full-spectrum legal services for business protection",
        details: [
          "Trademark registration (India & US)",
          "Contract drafting and review",
          "MCA compliance (India)",
          "State compliance (US)",
          "IP protection strategy"
        ]
      },
      { 
        title: "Compliance Management", 
        desc: "Regulatory compliance services for businesses",
        details: [
          "Annual compliance filings",
          "ROC returns (India)",
          "State business filings (US)",
          "Industry-specific compliance",
          "Compliance calendar management"
        ]
      },
      { 
        title: "Corporate Governance", 
        desc: "Advisory services for corporate structure and policies",
        details: [
          "Board meeting support",
          "Corporate secretarial services",
          "Policy framework development",
          "ESG compliance advisory",
          "Risk management frameworks"
        ]
      }
    ]
  },
  {
    category: "Digital Solutions",
    services: [
      { 
        title: "Web Development", 
        desc: "Custom digital solutions for online presence",
        details: [
          "Responsive website design",
          "E-commerce platforms",
          "Web applications",
          "CMS implementation",
          "SEO-friendly development"
        ]
      },
      { 
        title: "IT Solutions", 
        desc: "Technology solutions for business efficiency",
        details: [
          "Custom software development",
          "CRM/ERP integration",
          "Cloud migration",
          "API development",
          "Legacy system modernization"
        ]
      },
      { 
        title: "IT Maintenance", 
        desc: "Ongoing support for digital assets",
        details: [
          "24/7 website monitoring",
          "Security updates",
          "Performance optimization",
          "Backup management",
          "Analytics reporting"
        ]
      },
      { 
        title: "AI Chatbot Automation", 
        desc: "Boost eCommerce sales with automated messaging & support bots",
        details: [
          "WhatsApp & Instagram order alerts",
          "Automated product FAQs & recommendations",
          "Abandoned cart recovery messages",
          "Multi-platform chatbot support",
          "Google Sheets & Shopify integrations"
        ]
      },
      { 
        title: "Cloud Services", 
        desc: "Comprehensive cloud computing solutions",
        details: [
          "Cloud infrastructure setup",
          "SaaS application deployment",
          "Data migration services",
          "Cloud security solutions",
          "Cost optimization consulting"
        ]
      },
      { 
        title: "Data Analytics", 
        desc: "Business intelligence and data-driven decision making",
        details: [
          "Dashboard development",
          "Predictive analytics",
          "Customer behavior analysis",
          "Sales forecasting",
          "Data visualization"
        ]
      }
    ]
  },
  {
    category: "Marketing & Branding",
    services: [
      { 
        title: "Digital Marketing", 
        desc: "Data-driven online marketing strategies",
        details: [
          "SEO optimization",
          "PPC campaign management",
          "Content marketing",
          "Conversion rate optimization",
          "Marketing automation"
        ]
      },
      { 
        title: "Graphic Design", 
        desc: "Visual identity and branding solutions",
        details: [
          "Logo and brand identity",
          "Marketing collateral",
          "Presentation design",
          "Infographics",
          "Product packaging"
        ]
      },
      { 
        title: "Social Media", 
        desc: "Comprehensive social media management",
        details: [
          "Content strategy",
          "Community management",
          "Influencer partnerships",
          "Paid social advertising",
          "Performance analytics"
        ]
      }
    ]
  },
  {
    category: "Business Growth",
    services: [
      { 
        title: "Business Consulting", 
        desc: "Strategic advisory for expansion",
        details: [
          "Market entry strategy",
          "Competitive analysis",
          "Funding strategy",
          "Operational efficiency",
          "Exit planning"
        ]
      },
      { 
        title: "Content Services", 
        desc: "Professional content creation",
        details: [
          "Website copywriting",
          "Blog content",
          "Email campaigns",
          "Whitepapers",
          "Technical documentation"
        ]
      },
      { 
        title: "E-commerce Solutions", 
        desc: "Growth strategies for online stores",
        details: [
          "Conversion optimization",
          "Retargeting campaigns",
          "Loyalty programs",
          "Marketplace integration",
          "Inventory management"
        ]
      }
    ]
  },
  {
    category: "HR & Operations",
    services: [
      { 
        title: "HR Support", 
        desc: "Comprehensive human resources solutions",
        details: [
          "Recruitment process",
          "Employee onboarding",
          "Performance management",
          "HR compliance",
          "Policy development"
        ]
      },
      { 
        title: "Business Essentials", 
        desc: "Operational support services",
        details: [
          "Corporate identity materials",
          "Branded merchandise",
          "Office space planning",
          "Vendor management",
          "Operational documentation"
        ]
      },
      { 
        title: "Virtual Assistance", 
        desc: "Remote operational support for businesses",
        details: [
          "Administrative support",
          "Calendar management",
          "Customer service",
          "Data entry services",
          "Project coordination"
        ]
      }
    ]
  }
];

    return (
    <>
      <Navbar />
      <div className="kr-services">
        {/* Hero Section with animations */}
        <header className="kr-services__hero" data-aos="fade-up">
          <div className="kr-services__hero-content">
            <img 
              src={logo} 
              alt="Krinvy Services" 
              className="kr-services__logo"
              data-aos="fade-right"
              data-aos-delay="100"
            />
            <div className="kr-services__hero-text" data-aos="fade-left" data-aos-delay="200">
              <h1 className="kr-services__title">Our Service Portfolio</h1>
              <p className="kr-services__subtitle">
                Comprehensive business solutions across six key categories...
              </p>
              <p className="kr-services__subtitle">
                Carefully curated services across six core business functions
              </p>
            </div>
          </div>
        </header>

        {/* Services Grid with staggered animations */}
        <main className="kr-services__main">
          <div className="kr-services__container">
            {serviceCategories.map((category, catIndex) => (
              <section 
                key={catIndex} 
                className="kr-services__category"
                data-aos="fade-up"
                data-aos-delay={catIndex * 50}
              >
                <div className="kr-services__category-header">
                  <h3 className="kr-services__category-title">{category.category}</h3>
                </div>
                
                <div className="kr-services__grid">
                  {category.services.map((service, index) => (
                    <article 
                      key={index} 
                      className="kr-services__card"
                      data-aos="zoom-in"
                      data-aos-delay={100 + (index * 50)}
                    >
                      <div className="kr-services__card-header">
                        <h4 className="kr-services__card-title">{service.title}</h4>
                        <div className="kr-services__card-icon"></div>
                      </div>
                      <p className="kr-services__description">{service.desc}</p>
                      <ul className="kr-services__features">
                        {service.details.map((detail, i) => (
                          <li key={i} className="kr-services__feature-item">
                            {detail}
                          </li>
                        ))}
                      </ul>
                    </article>
                  ))}
                </div>
              </section>
            ))}
          </div>
        </main>
      </div>
      <Scrolltop />
      <WhatsAppChatButton />
      <Cosection setShowQuoteModal={setShowQuoteModal} />
      <Footer />
    </>
  );
};

export default Services;